export interface ScreeningCheck {
  id: string;
  name: string;
}

// Sanctions Lists
export const SANCTIONS_LISTS: ScreeningCheck[] = [
  {
    id: 'UK',
    name: 'UK Sanctions List',
  },
  {
    id: 'US',
    name: 'US Consolidated Sanctions List (OFAC)',
  },
  {
    id: 'UN',
    name: 'UN Sanctions List',
  },
  {
    id: 'EU',
    name: 'EU Sanctions List',
  },
];

// Additional Screening Checks
export const ADDITIONAL_CHECKS: ScreeningCheck[] = [
  {
    id: 'PEP',
    name: 'Politically Exposed Persons (PEP)',
  },
  {
    id: 'ADVERSE_MEDIA',
    name: 'Adverse Media',
  },
  {
    id: 'COMPANIES_HOUSE',
    name: 'Companies House',
  },
  {
    id: 'CPI',
    name: 'Corruption Perceptions Index (CPI)',
  },
  {
    id: 'FATF',
    name: 'Financial Action Task Force (FATF)',
  },
];

// All screening checks combined
export const ALL_SCREENING_CHECKS: ScreeningCheck[] = [...SANCTIONS_LISTS, ...ADDITIONAL_CHECKS];

// Default checks selected when the form loads (UK is pre-selected but optional)
export const DEFAULT_SELECTED_CHECKS = ['UK'];

// No checks are required - all are optional (but at least one must be selected to submit)
export const REQUIRED_CHECKS: string[] = [];

export function getDefaultSelectedLists(): string[] {
  return DEFAULT_SELECTED_CHECKS;
}

export function isRequiredCheck(id: string): boolean {
  return REQUIRED_CHECKS.includes(id);
}

// Legacy export for backwards compatibility
export type SanctionsList = ScreeningCheck;
